/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：390
 */

"use strict"

export { r as b }
export { _9C90A8 as a }
var r = ["#FF6A3A", "#5B81FD", "#FFEC3D", "#73D13D", "#F759AB", "#FFA332", "#3BA7FF", "#F9CC37", "#5AB45B", "#FF85C0", "#F9CC37", "#BAE637", "#FF4D4F", "#36CFC9", "#82778C"]
var /* [auto-meaningful-name] */_9C90A8 = "#9C90A8"
export default _9C90A8
